/** Valid provider modes — single source of truth for validation. */
export const VALID_AGENT_PROVIDER_MODES = [
    'sam',
    'user-api-key',
    'oauth',
];
export const DEFAULT_OPENCODE_PROVIDER = 'opencode-zen';
export const DEFAULT_OPENCODE_ZEN_MODEL = 'opencode/claude-sonnet-4-6';
export const DEFAULT_OPENCODE_GO_MODEL = 'opencode-go/glm-5.2';
/** Provider metadata registry — used by both UI and validation */
export const OPENCODE_PROVIDERS = {
    'opencode-zen': {
        label: 'OpenCode Zen',
        modelPlaceholder: `e.g. ${DEFAULT_OPENCODE_ZEN_MODEL}`,
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'OpenCode API Key',
        keyHelpText: 'Create an OpenCode API key at opencode.ai/auth',
    },
    'opencode-go': {
        label: 'OpenCode Go',
        modelPlaceholder: `e.g. ${DEFAULT_OPENCODE_GO_MODEL}`,
        requiresBaseUrl: false,
        requiresApiKey: true,
        keyLabel: 'OpenCode API Key',
        keyHelpText: 'Create an OpenCode API key at opencode.ai/auth',
    },
    custom: {
        label: 'Custom (OpenAI-compatible)',
        modelPlaceholder: 'e.g. your-model-name',
        requiresBaseUrl: true,
        requiresApiKey: true,
        keyLabel: 'API Key',
        keyHelpText: 'Enter the base URL and API key for your OpenAI-compatible endpoint',
    },
};
/** Ordered list of OpenCode provider values for dropdown rendering */
export const OPENCODE_PROVIDER_OPTIONS = [
    'opencode-zen',
    'opencode-go',
    'custom',
];
export function resolveOpenCodeProvider(raw) {
    if (typeof raw === 'string' && Object.hasOwn(OPENCODE_PROVIDERS, raw)) {
        return raw;
    }
    return DEFAULT_OPENCODE_PROVIDER;
}
// =============================================================================
// Agent Effort
// =============================================================================
export const AGENT_EFFORT_LEVELS = ['auto', 'low', 'medium', 'high', 'xhigh', 'max'];
export const DEFAULT_AGENT_EFFORT = 'auto';
export function isAgentEffort(value) {
    return typeof value === 'string' && AGENT_EFFORT_LEVELS.includes(value);
}
export function getSupportedEffortsForAgent(agentType) {
    switch (agentType) {
        case 'claude-code':
            return AGENT_EFFORT_LEVELS;
        case 'openai-codex':
            return ['auto', 'low', 'medium', 'high', 'xhigh'];
        default:
            return ['auto'];
    }
}
export function isAgentEffortSupported(agentType, effort) {
    return getSupportedEffortsForAgent(agentType).includes(effort);
}
export const AGENT_PROFILE_RUNTIMES = ['vm', 'cf-container'];
export function isAgentProfileRuntime(value) {
    return typeof value === 'string' && AGENT_PROFILE_RUNTIMES.includes(value);
}
export const GITHUB_CLI_POLICY_PERMISSION_KEYS = [
    'contents',
    'pullRequests',
    'issues',
    'actions',
    'packages',
];
export const DEFAULT_GITHUB_CLI_POLICY = {
    mode: 'inherit',
    repositoryScope: 'project',
    permissions: {
        contents: 'write',
        pullRequests: 'write',
        issues: 'write',
        actions: 'none',
        packages: 'write',
    },
};
//# sourceMappingURL=agent-settings.js.map